const prod = process.env.REACT_APP_PROD;
//let dev = 'https://swh.bwdb.gov.bd';
let dev = process.env.REACT_APP_DEV;
// dev = 'http://localhost:8000';

export const BASE_URL = process.env.NODE_ENV === 'production' ?  prod : dev

export const MAP_CONFIG = {
  longitude: 90.54,
  latitude: 27.37,
  zoom: 8,
};

export const ADMINISTRATIVE_DIVISIONS = [
  { name: "province", file: "geojson/province.json", label: "Province", key: "STATE" },
  { name: 'district', file: 'geojson/district.json', label: 'District', key: 'DIST_EN' },
  { name: 'basin', file: 'geojson/basin.json', label: 'Basin', key: 'BASIN_NAME' },
]

export const ENABLE_AGG_FEATURES = false;
export const leafletURL = `https://api.mapbox.com/styles/v1/mapbox/streets-v10/tiles/256/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}`;



// WEBPACK FOOTER //
// ./src/config.js